import axios from "axios";
import { toast } from "react-toastify";

export const getLeagueLeaderboard = async (clubID, token, data) => {
  // "";
  try {
    let year, month;

    if (data?.year) {
      year = data.year;
    } else if (data?.month) {
      month = data.month;
    }
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL_USER}/leagues/getAllGoals/${clubID}?year=${year}&month=${month}`,

      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    toast.error("error fetching leaderboard!!");
    // throw new Error(error.message);
  }
};
